import { PageHeaderActionsPortal, GuideLinkButton, EnterpriseLinkIconButton } from '@mews-commander/ui';
import { IconName } from '@optimus-web/icons';
import { useDateTimeLocalizationInfo, useTimezone, useAppClockService, lt } from '@mews/framework';
import { useRepositorySuspenseQuery } from '@mews-commander/data-access';
import { TextKey, ArticlePath, createGuideLink } from '@mews-commander/enums';
import { useCurrentEnterpriseId } from '@mews-commander/core';
import { getMailQueueItemQuery } from '../../../../utils/getMailQueueItemQuery';
import { AddButton } from './AddButton';

export const DashboardTabActions = ({ customerId }: { customerId: string }) => {
    const currentEnterpriseId = useCurrentEnterpriseId();
    const localizationInfo = useDateTimeLocalizationInfo();
    const timezone = useTimezone();
    const appClockService = useAppClockService();
    const nowUtc = appClockService.getAppNowUtc().value;

    const { data: customer } = useRepositorySuspenseQuery(
        'accounts',
        'getAll',
        { accountIds: [customerId] },
        { select: ({ customers }) => customers?.[0] }
    );

    return (
        <PageHeaderActionsPortal>
            <AddButton customerId={customerId} />
            <EnterpriseLinkIconButton
                to="MailQueueItem/Index"
                search={getMailQueueItemQuery({
                    enterpriseId: currentEnterpriseId,
                    email: customer?.email,
                    nowUtc,
                    timezone,
                    localizationInfo,
                })}
                tooltip={lt(TextKey.MailQueueItemPlural)}
                icon={IconName.EmailQueue}
                type="button"
            />
            <GuideLinkButton guideLink={createGuideLink(ArticlePath.UpdateDeleteCustomerProfile)} />
        </PageHeaderActionsPortal>
    );
};
